import { Box, Grid, Typography } from '@mui/material'
import { Button } from 'ui-components'
import { RepairShopSearchResultDto } from '@src/model/repairShopDom'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import RepairShopList from './RepairShopList'

interface RepairShopSelectionProps {
  uuid: string
  repairShops: RepairShopSearchResultDto[]
}

const RepairShopSelection = ({
  uuid,
  repairShops,
}: RepairShopSelectionProps) => {
  const { t } = useTranslation('repairshop')
  const [selection, setSelection] = useState<number | null>(null)

  return (
    <form>
      <Box
        sx={{
          py: 2,
          px: 3,
          margin: 'auto',
          maxWidth: 'lg',
        }}
        id={'repair-shop-selection-header'}
      >
        <Typography variant="h2" gutterBottom>
          {t('selection-page.select-repair-shop')}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {t('selection-page.select-repair-shop-info')}
        </Typography>
      </Box>
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <RepairShopList
            radioGroupAriaLabelledby={'repair-shop-selection-header'}
            repairShops={repairShops}
            selectedMatch={selection}
            onSelect={(matchId) => setSelection(matchId)}
          />
        </Grid>
        <Grid item xs={12}>
          <Box p={2}>
            <Button
              href={`/${uuid}/valinta/${selection}`}
              data-testid={'selection-page.continue-to-check-your-details'}
              fullWidth
              variant="contained"
              color={'primaryLight'}
              disabled={!selection}
              sx={{
                outline: 0,
                backgroundColor: 'secondary',
                py: 1,
                border: 'none',
                '&.MuiButton-root:disabled': {
                  border: 'none',
                  outline: 0,
                },
              }}
            >
              {t('selection-page.continue-to-check-your-details-page-button')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  )
}

export default RepairShopSelection
